import { render, staticRenderFns } from "./activity-item.vue?vue&type=template&id=fc90394e&scoped=true"
import script from "./activity-item.vue?vue&type=script&lang=js"
export * from "./activity-item.vue?vue&type=script&lang=js"
import style0 from "./activity-item.vue?vue&type=style&index=0&id=fc90394e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc90394e",
  null
  
)

export default component.exports